const binding = { modules: {}, dataActions: {} };

    (binding.modules['catalog-checker'] = {
        c: () => require('partner/modules/catalog-checker/catalog-checker.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'catalog-checker',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/catalog-checker'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };